import Services from 'utils/services';
import {
  SHOULD_UPDATE_FOLLOWING_STATUS,
  SUCCESS_GET_SUGGESTED_ATHLETES,
  SUCCESS_GET_TEAMMATES,
  SUCCESS_MODAL_GET_SUGGESTED_ATHLETES,
  UPDATE_FOLLOWING_STATUS,
  UPDATE_IS_FETCHING_ATHLETES,
  UPDATE_IS_FETCHING_SUGGESTIONS,
  UPDATE_WIDGET_IS_FETCHING_SUGGESTIONS,
  UPDATE_SHOW_TEAMMATES_STATUS,
  UPDATE_SHOW_ONBOARDING_BEACON,
  FAIL_RECEIVE_SUGGESTED_ATHLETES,
  FAIL_FOLLOW_TEAM,
  FAIL_UNFOLLOW_TEAM,
  UPDATE_HAS_MORE_SUGGESTIONS,
  UPDATE_SHOULD_REFRESH_SUGGESTIONS,
  UPDATE_DISPLAY_SUGGESTIONS_MODAL,
} from './actionTypes';
import { setUserFollow } from './actionCreators';

function failReceivedSuggestedAthlete() {
  return {
    type: FAIL_RECEIVE_SUGGESTED_ATHLETES,
    payload: {},
  };
}

function failFollowTeam() {
  return {
    type: FAIL_FOLLOW_TEAM,
    payload: {},
  };
}

function failUnfollowTeam() {
  return {
    type: FAIL_UNFOLLOW_TEAM,
    payload: {},
  };
}

function updateIsFetchingStatus(type, isFetching) {
  return {
    type: type,
    payload: {
      isFetching,
    },
  };
}

function receiveSuggestedAthletes(suggestedAthletes, maxScore) {
  return {
    type: SUCCESS_GET_SUGGESTED_ATHLETES,
    payload: {
      suggestedAthletes,
      maxScore,
    },
  };
}

function receiveModalSuggestedAthletes(modalSuggestedAthletes) {
  return {
    type: SUCCESS_MODAL_GET_SUGGESTED_ATHLETES,
    payload: {
      modalSuggestedAthletes,
    },
  };
}

function receiveTeammates(teammates, hasMoreTeammates, showTeammates) {
  return {
    type: SUCCESS_GET_TEAMMATES,
    payload: {
      teammates,
      showTeammates,
      hasMoreTeammates,
    },
  };
}

export function updateShowHideSuggestionsModal(shouldShowModal) {
  return {
    type: UPDATE_DISPLAY_SUGGESTIONS_MODAL,
    payload: {
      shouldShowModal,
    },
  };
}

export function updateShouldRefreshSuggestions(refreshSuggestions) {
  return {
    type: UPDATE_SHOULD_REFRESH_SUGGESTIONS,
    payload: {
      refreshSuggestions,
    },
  };
}

export function updateShowOnBoardingBeacon(showOnboardingBeacon) {
  return {
    type: UPDATE_SHOW_ONBOARDING_BEACON,
    payload: {
      showOnboardingBeacon,
    },
  };
}

export function updateHasMoreSuggestions(newValue) {
  return {
    type: UPDATE_HAS_MORE_SUGGESTIONS,
    payload: {
      newValue,
    },
  };
}

export function shouldCheckForFollowingTeamUpdates(newValue) {
  return {
    type: SHOULD_UPDATE_FOLLOWING_STATUS,
    payload: {
      newValue,
    },
  };
}

export function updateFollowingTeamStatus(newValue) {
  return {
    type: UPDATE_FOLLOWING_STATUS,
    payload: {
      newValue,
    },
  };
}

export function updateShowTeammates(showTeammates) {
  return {
    type: UPDATE_SHOW_TEAMMATES_STATUS,
    payload: {
      showTeammates,
    },
  };
}

function isFollowingTeam() {
  return (dispatch, getState) => {
    let userIsFollowingTeam = true;
    const teammates = getState().featuredAthletes.contentFeatureAthletes.teammates || [];
    const userFollows = getState().follow.userFollows;

    teammates.forEach(athlete => {
      const userId = athlete.feedUserId.type + '-' + athlete.feedUserId.relatedId;
      const isFollowing = userFollows[userId];
      if (!athlete.isFollowing && !isFollowing) {
        userIsFollowingTeam  = false;
      }
    });
    return userIsFollowingTeam;
  };
}

function isNotFollowingTeam() {
  return (dispatch, getState) => {
    let userIsFollowingTeam = false;
    const teammates = getState().featuredAthletes.contentFeatureAthletes.teammates || [];
    const userFollows = getState().follow.userFollows;

    teammates.forEach(athlete => {
      const userId = athlete.feedUserId.type + '-' + athlete.feedUserId.relatedId;
      const isFollowing = userFollows[userId];
      if (athlete.isFollowing || isFollowing) {
        userIsFollowingTeam  = true;
      }
    });

    return !userIsFollowingTeam;
  };
}

export function checkForFollowingTeamUpdates() {
  return (dispatch, getState) => {
    const hasMoreTeammates = getState().featuredAthletes.contentFeatureAthletes.hasMoreTeammates;
    const currentFollowStatus = getState().featuredAthletes.contentSuggestionsWidget.isFollowingTeam;
    const userIsFollowingTeam = dispatch(isFollowingTeam());
    const userIsNotFollowingTeam = dispatch(isNotFollowingTeam());

    if (!hasMoreTeammates) {
      if (!currentFollowStatus && userIsFollowingTeam) {
        dispatch(updateFollowingTeamStatus(true));
      } else if (currentFollowStatus && userIsNotFollowingTeam) {
        dispatch(updateFollowingTeamStatus(false));
      } else {
        dispatch(shouldCheckForFollowingTeamUpdates(false));
      }
    } else {
      dispatch(shouldCheckForFollowingTeamUpdates(false));
    }
  };
}

export function getSuggestedAthletes(onlyTeammates, excludedAthleteIds, maxScore, count) {
  return (dispatch, getState) => {
    const requestData = {
      onlyTeammates: onlyTeammates,
      excludeAthleteIds: excludedAthleteIds,
      maxScore: maxScore,
      count: count,
    };

    let type = onlyTeammates ? UPDATE_IS_FETCHING_ATHLETES : UPDATE_IS_FETCHING_SUGGESTIONS;
    type = count ? type : UPDATE_WIDGET_IS_FETCHING_SUGGESTIONS;

    dispatch(updateIsFetchingStatus(type, true));

    Services.getSuggestedAthletes(requestData)
      .fail(() => dispatch(failReceivedSuggestedAthlete()))
      .done(athletes => {
        athletes.forEach(athlete => {
          excludedAthleteIds.push(athlete.feedUserId.relatedId);

          // The `positions` property is already formatted as a string.
          // Most other endpoints return an array of strings, so we'll
          // need to accommodate this with an additional PropType.
          athlete.formattedPositions = athlete.positions;
          delete athlete.positions;
        });

        if (onlyTeammates) {
          const userIsFollowingTeam = getState().featuredAthletes.contentSuggestionsWidget.isFollowingTeam || false;

          if (userIsFollowingTeam) {
            // Update the follow status for each user to ensure we have the latest state
            athletes.forEach(({ feedUserId })  => {
              const { type: feedUserType, relatedId: feedUserRelatedId } = feedUserId;
              dispatch(setUserFollow(feedUserType, feedUserRelatedId, true));
            });
          }

          const previousTeammates = getState().featuredAthletes.contentFeatureAthletes.teammates || [];
          const newTeammates = previousTeammates.concat(athletes);
          const hasMore = athletes.length === count;
          const showTeammates = newTeammates.length !== 0;

          dispatch(receiveTeammates(newTeammates, hasMore, showTeammates));
        } else {
          if (athletes.length > 0) {
            const newMaxScore = athletes[athletes.length - 1].score;

            if (count) {
              dispatch(receiveModalSuggestedAthletes(athletes));
            } else {
              dispatch(receiveSuggestedAthletes(athletes, newMaxScore));
            }
          } else {
            dispatch(updateHasMoreSuggestions(false));
          }
        }

        dispatch(updateIsFetchingStatus(type, false));
      });
  };
}

function followTeam() {
  return (dispatch, getState) => {
    const requestData = {
      includeAthletes: true,
      logData: { Origin: 'SuggestedFollowers' },
    };

    Services.followTeam(requestData)
      .fail(() => dispatch(failFollowTeam()))
      .done(() => {
        const teammates = getState().featuredAthletes.contentFeatureAthletes.teammates || [];

        // Update the follow status for each user to ensure we have the latest state
        teammates.forEach(({ feedUserId }) => {
          const { type: feedUserType, relatedId: feedUserRelatedId } = feedUserId;
          dispatch(setUserFollow(feedUserType, feedUserRelatedId, true));
        });

        dispatch(updateFollowingTeamStatus(true));
      });
  };
}

function unfollowTeam() {
  return (dispatch, getState) => {
    const requestData = {
      includeAthletes: true,
      logData: { Origin: 'SuggestedFollowers' },
    };

    Services.unfollowTeam(requestData)
      .fail(() => dispatch(failUnfollowTeam()))
      .done(() => {
        const teammates = getState().featuredAthletes.contentFeatureAthletes.teammates || [];

        // Update the follow status for each user to ensure we have the latest state
        teammates.forEach(({ feedUserId }) => {
          const { type: feedUserType, relatedId: feedUserRelatedId } = feedUserId;
          dispatch(setUserFollow(feedUserType, feedUserRelatedId, false));
        });

        dispatch(updateFollowingTeamStatus(false));
      });
  };
}

export function followUnfollowTeam() {
  return (dispatch, getState) => {
    const userIsFollowingTeam = getState().featuredAthletes.contentSuggestionsWidget.isFollowingTeam;
    if (userIsFollowingTeam) {
      dispatch(unfollowTeam());
    } else {
      dispatch(followTeam());
    }
  };
}
